module.exports = __webpack_public_path__ + "img/file-1561751898596.f7cb28d2.jpeg";